'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTrash, iconTrashTag } from '@ni/nimble-components/dist/esm/icons/trash';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTrash };
export { iconTrashTag };
export const NimbleIconTrash = wrap(IconTrash);